import React from "react";

import AlignmentViewCell from "./AlignmentViewCell";
import {
  AlignmentViewRowData,
  AlignmentViewRowVisibility,
} from "./AlignmentViewData";

type Props = {
  data: AlignmentViewRowData;
  visibility: AlignmentViewRowVisibility;
};

const AlignmentViewRow = ({ data, visibility }: Props) => {
  const rowRef = React.useRef<HTMLTableRowElement>(null);

  if (!visibility.isVisible) {
    return null;
  }

  return (
    <tr ref={rowRef}>
      {data.cells?.map((cell, i) => {
        return (
          <AlignmentViewCell
            key={i}
            data={cell}
            visibility={visibility.cells[i]}
          />
        );
      })}
    </tr>
  );
};

export default AlignmentViewRow;
